// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Page-change animations (\`uiEffects.transition\`) for the page \`<ViewTransition>\` in \`App.tsx\`.
 * React tags the page with a View Transition Class named after the transition type (\`page-<direction>-<orientation>\`)
 * and runs \`document.startViewTransition\` itself. Per the Style Guide prototype, all 300 ms ease-out:
 * - horizontal (Slide in / out): the new page slides over the old one, which shifts 30% the same way and dims;
 *   back plays it in reverse. The dimming is the moving page's full-screen shadow (the only way to paint between
 *   the two snapshots), so it follows the movement. Its colour is \`--page-transition-dim\`, set by the resolver
 *   from the \`OverlayDarkening\` token of the current design generation.
 * - vertical (Move in / out): the new page moves over the old one, which stays still and undimmed; back reverses.
 */

/* No size morph between the two pages: both snapshots keep their own height, pinned to the top. */
::view-transition-group(.page-forward-horizontal),
::view-transition-group(.page-back-horizontal),
::view-transition-group(.page-forward-vertical),
::view-transition-group(.page-back-vertical) {
    animation: none;
}

::view-transition-old(.page-forward-horizontal),
::view-transition-new(.page-forward-horizontal),
::view-transition-old(.page-back-horizontal),
::view-transition-new(.page-back-horizontal),
::view-transition-old(.page-forward-vertical),
::view-transition-new(.page-forward-vertical),
::view-transition-old(.page-back-vertical),
::view-transition-new(.page-back-vertical) {
    animation: none;
    mix-blend-mode: normal;
    height: auto;
    object-fit: none;
    object-position: top;
}

/* The moving page is always the one on top. */
::view-transition-new(.page-forward-horizontal),
::view-transition-new(.page-forward-vertical),
::view-transition-old(.page-back-horizontal),
::view-transition-old(.page-back-vertical) {
    z-index: 1;
}

::view-transition-new(.page-forward-horizontal) {
    animation:
        page-slide-from-right 300ms ease-out both,
        page-dim-underneath 300ms ease-out both;
}

::view-transition-old(.page-forward-horizontal) {
    animation: page-shift-to-left 300ms ease-out both;
}

::view-transition-old(.page-back-horizontal) {
    animation:
        page-slide-to-right 300ms ease-out both,
        page-undim-underneath 300ms ease-out both;
}

::view-transition-new(.page-back-horizontal) {
    animation: page-shift-from-left 300ms ease-out both;
}

::view-transition-new(.page-forward-vertical) {
    animation: page-move-from-bottom 300ms ease-out both;
}

::view-transition-old(.page-back-vertical) {
    animation: page-move-to-bottom 300ms ease-out both;
}

@keyframes page-slide-from-right {
    from {
        transform: translateX(100%);
    }
}

@keyframes page-slide-to-right {
    to {
        transform: translateX(100%);
    }
}

/* Parallax of the page underneath a horizontal slide. */
@keyframes page-shift-to-left {
    to {
        transform: translateX(-30%);
    }
}

@keyframes page-shift-from-left {
    from {
        transform: translateX(-30%);
    }
}

@keyframes page-move-from-bottom {
    from {
        transform: translateY(100%);
    }
}

@keyframes page-move-to-bottom {
    to {
        transform: translateY(100%);
    }
}

@keyframes page-dim-underneath {
    from {
        box-shadow: 0 0 0 100vmax transparent;
    }
    to {
        box-shadow: 0 0 0 100vmax var(--page-transition-dim);
    }
}

@keyframes page-undim-underneath {
    from {
        box-shadow: 0 0 0 100vmax var(--page-transition-dim);
    }
    to {
        box-shadow: 0 0 0 100vmax transparent;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/pageTransition/pageTransitions.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF,kGAAkG;AAClG;;;;IAII,eAAe;AACnB;;AAEA;;;;;;;;IAQI,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,8CAA8C;AAC9C;;;;IAII,UAAU;AACd;;AAEA;IACI;;+CAE2C;AAC/C;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI;;iDAE6C;AACjD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA,wDAAwD;AACxD;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;IACA;QACI,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,oDAAoD;IACxD;IACA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":["/*\n * Page-change animations (`uiEffects.transition`) for the page `<ViewTransition>` in `App.tsx`.\n * React tags the page with a View Transition Class named after the transition type (`page-<direction>-<orientation>`)\n * and runs `document.startViewTransition` itself. Per the Style Guide prototype, all 300 ms ease-out:\n * - horizontal (Slide in / out): the new page slides over the old one, which shifts 30% the same way and dims;\n *   back plays it in reverse. The dimming is the moving page's full-screen shadow (the only way to paint between\n *   the two snapshots), so it follows the movement. Its colour is `--page-transition-dim`, set by the resolver\n *   from the `OverlayDarkening` token of the current design generation.\n * - vertical (Move in / out): the new page moves over the old one, which stays still and undimmed; back reverses.\n */\n\n/* No size morph between the two pages: both snapshots keep their own height, pinned to the top. */\n::view-transition-group(.page-forward-horizontal),\n::view-transition-group(.page-back-horizontal),\n::view-transition-group(.page-forward-vertical),\n::view-transition-group(.page-back-vertical) {\n    animation: none;\n}\n\n::view-transition-old(.page-forward-horizontal),\n::view-transition-new(.page-forward-horizontal),\n::view-transition-old(.page-back-horizontal),\n::view-transition-new(.page-back-horizontal),\n::view-transition-old(.page-forward-vertical),\n::view-transition-new(.page-forward-vertical),\n::view-transition-old(.page-back-vertical),\n::view-transition-new(.page-back-vertical) {\n    animation: none;\n    mix-blend-mode: normal;\n    height: auto;\n    object-fit: none;\n    object-position: top;\n}\n\n/* The moving page is always the one on top. */\n::view-transition-new(.page-forward-horizontal),\n::view-transition-new(.page-forward-vertical),\n::view-transition-old(.page-back-horizontal),\n::view-transition-old(.page-back-vertical) {\n    z-index: 1;\n}\n\n::view-transition-new(.page-forward-horizontal) {\n    animation:\n        page-slide-from-right 300ms ease-out both,\n        page-dim-underneath 300ms ease-out both;\n}\n\n::view-transition-old(.page-forward-horizontal) {\n    animation: page-shift-to-left 300ms ease-out both;\n}\n\n::view-transition-old(.page-back-horizontal) {\n    animation:\n        page-slide-to-right 300ms ease-out both,\n        page-undim-underneath 300ms ease-out both;\n}\n\n::view-transition-new(.page-back-horizontal) {\n    animation: page-shift-from-left 300ms ease-out both;\n}\n\n::view-transition-new(.page-forward-vertical) {\n    animation: page-move-from-bottom 300ms ease-out both;\n}\n\n::view-transition-old(.page-back-vertical) {\n    animation: page-move-to-bottom 300ms ease-out both;\n}\n\n@keyframes page-slide-from-right {\n    from {\n        transform: translateX(100%);\n    }\n}\n\n@keyframes page-slide-to-right {\n    to {\n        transform: translateX(100%);\n    }\n}\n\n/* Parallax of the page underneath a horizontal slide. */\n@keyframes page-shift-to-left {\n    to {\n        transform: translateX(-30%);\n    }\n}\n\n@keyframes page-shift-from-left {\n    from {\n        transform: translateX(-30%);\n    }\n}\n\n@keyframes page-move-from-bottom {\n    from {\n        transform: translateY(100%);\n    }\n}\n\n@keyframes page-move-to-bottom {\n    to {\n        transform: translateY(100%);\n    }\n}\n\n@keyframes page-dim-underneath {\n    from {\n        box-shadow: 0 0 0 100vmax transparent;\n    }\n    to {\n        box-shadow: 0 0 0 100vmax var(--page-transition-dim);\n    }\n}\n\n@keyframes page-undim-underneath {\n    from {\n        box-shadow: 0 0 0 100vmax var(--page-transition-dim);\n    }\n    to {\n        box-shadow: 0 0 0 100vmax transparent;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
